import type { PasswordField } from "../model/validatePasswords";

interface PasswordInputConfig {
  field: PasswordField;
  placeholder: string;
  autoComplete: string;
}

export const PASSWORD_INPUTS: PasswordInputConfig[] = [
  {
    field: "current",
    placeholder: "Current password",
    autoComplete: "current-password",
  },
  { field: "next", placeholder: "New password", autoComplete: "new-password" },
  {
    field: "confirm",
    placeholder: "Confirm new password",
    autoComplete: "new-password",
  },
];
